export default __webpack_public_path__ + "static/media/metamask-fox-wordmark-horizontal.093c9b19.svg";